// Mock data for RamonGovea.com landing page

export const heroData = {
  headline: "High-End Commercials. Delivered Faster.",
  subheadline: "Senior creative producer delivering AI-powered commercials, websites, and digital experiences for brands that need speed—without sacrificing polish.",
  ctaText: "Start a Project",
  proofLine: "Trusted by Hollywood studios, growing brands, and agency teams."
};

export const navigationLinks = [
  { label: "Work", href: "/#work" },
  { label: "Services", href: "/#services" },
  { label: "About", href: "/#about" },
  { label: "Work With Me", href: "/work-with-me" },
  { label: "Classroom", href: "/ai-tools-for-creatives" },
  { label: "Contact", href: "/#contact" }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Newman Injury Law",
    type: "Cinematic Local Brand Ad",
    videoId: "pIrpbPLO6zU"
  },
  {
    id: 2,
    title: "Newman Injury Law",
    type: "Cinematic Local Brand Ad",
    videoId: "Ua9JQEE2ejA"
  },
  {
    id: 3,
    title: "Diamond Club Matchmaking",
    type: "High-End Luxury Brand Promo",
    videoId: "4yFrl_5xk0w"
  },
  {
    id: 4,
    title: "King Fox Cleaners",
    type: "Premium Local Brand Commercial",
    videoId: "Su8trRf75uk"
  },
  {
    id: 5,
    title: "TEG Construction",
    type: "Regional Brand Promo Video",
    videoId: "5REC4oKo8No"
  },
  {
    id: 6,
    title: "The Faery Matchmaker",
    type: "Story-Driven Animated Series Concept",
    videoId: "6zl6_XK53vg"
  }
];

export const websiteItems = [
  {
    id: 1,
    title: "Diamond Club Matchmaking",
    type: "Website Design & Development",
    image: "https://customer-assets.emergentagent.com/job_premium-commercials/artifacts/gi4nf41v_Screenshot%202026-01-26%20at%2012.17.14%20PM.png",
    link: "https://diamondclubmatchmaking.com"
  },
  {
    id: 2,
    title: "I Deserve Love",
    type: "Website Design & Development",
    image: "https://customer-assets.emergentagent.com/job_premium-commercials/artifacts/uhg281f4_I%20Deserve%20Love%20Website.png",
    link: "https://ideservelove.com"
  },
  {
    id: 3,
    title: "King Fox Cleaners",
    type: "Website Design & Development",
    image: "https://customer-assets.emergentagent.com/job_premium-commercials/artifacts/u0nhkjwy_King%20Fox%20Cleaners%20Website.png",
    link: "https://kingfoxcleaners.com"
  },
  {
    id: 4,
    title: "Myth Division",
    type: "Website Design & Development",
    image: "https://customer-assets.emergentagent.com/job_premium-commercials/artifacts/m8e9fqxd_Myth%20Division%20Website.png",
    link: "https://mythdivision.com",
    imagePosition: "object-left"
  }
];

export const services = [
  {
    id: 1,
    title: "Commercials & Video Ads",
    description: "Short, punchy spots for web, social, and paid media."
  },
  {
    id: 2,
    title: "Brand Films",
    description: "Polished, story-driven videos that elevate perception."
  },
  {
    id: 3,
    title: "Short-Form Content",
    description: "Cutdowns and vertical versions optimized for reach."
  },
  {
    id: 4,
    title: "AI, Invisible to the Audience",
    description: "Modern tools used tastefully to move faster—without risk."
  },
  {
    id: 5,
    title: "Series Bibles & Pitch Decks",
    description: "Hollywood-ready story bibles and pitch materials for film, television, and franchise IP."
  },
  {
    id: 6,
    title: "Franchise & IP Development",
    description: "Creative development of original IP, story worlds, and scalable content ecosystems."
  },
  {
    id: 7,
    title: "Animated Shorts & Visual Concepts",
    description: "Stylized proof-of-concepts used to validate ideas, pitches, and product launches."
  },
  {
    id: 8,
    title: "Digital Experiences & Web Platforms",
    description: "Conversion-focused websites and launch pages built fast—without agency overhead."
  }
];

export const targetAudience = [
  {
    title: "Local & Regional Businesses",
    description: "Brands that want their content to feel premium, intentional, and competitive at a national level."
  },
  {
    title: "Marketing Teams",
    description: "In-house teams that need creative leadership, faster execution, and clean decision-making."
  },
  {
    title: "Agencies Seeking White-Label Support",
    description: "Agencies that want reliable, high-level production without expanding headcount."
  },
  {
    title: "Creators & IP Builders",
    description: "Founders, creators, and creative teams developing original IP, franchises, or content ecosystems who need experienced guidance on story, scale, and execution."
  }
];

export const audienceQualifier = "I work with a limited number of clients and consulting partners at any given time. Not every project is a fit.";

export const audienceCTA = "If you're serious about building something with long-term value, apply here and tell me what you're working on.";

export const audienceDisclaimer = "Please note: I can't accept or review unsolicited pitches, ideas, or materials that may overlap with existing or future projects.";

export const audienceTimingNote = "I work with a limited number of clients and fast-turn projects each month. If timing matters, say so in your application.";

export const contactData = {
  title: "Let's Talk",
  description: "Tell me what you're looking to build and how soon you need it—I'll let you know if I'm a fit.",
  submitText: "Start a Project",
  successMessage: "Thanks for reaching out. I personally review every inquiry and respond within 24 hours."
};
